import React, { useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import ContactFormSection from "./components/ContactForm/ContactForm";

import style from "./style.module.css";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className={style.ContactUsSection}>
        <header className={style.heroSection}></header>
        <div className={style.contactTextSection}>
          <h1>HERE TO SERVE YOU</h1>

          <p>
            We are so happy that you took the time to visit us and we welcome
            you to the IsKCON Vijayawada devotional family .Please write to us
            for any questions , to offer you services to Sri Sri Radha Madhava ,
            for information of any of our services and courses , or any
            suggestion . We are here to serve you , Hare Krishna!
          </p>

          <div className={style.RedLine}></div>
        </div>

        <ContactFormSection />
      </main>

      <Footer />
    </>
  );
};

export default ContactUs;
